import AxiosDefault from "services/AxiosDefault";

export const GetRevenueComparisonAPI = async (data) => {
  const response = await AxiosDefault({
    method: "POST",
    url: "/revenue-comparison/get",
    data,
  });
  return response;
};
